
const {
  API_KEY,
  API_SECRET,
  API_BASE_URL,
  API_DEVICE_ID,
  API_SSO_URL,
  API_CLIENT_ID,
  API_CLIENT_SECRET,
  GOOGLE_API_KEY,
  API_IRS_URL,
  ENABLED_COMPONENTS,
  SSO_MANAGEMENT_ONLY,
} = process.env;

const configs = {
  apiKey: API_KEY,
  secret: API_SECRET,
  baseUrl: API_BASE_URL,
  deviceId: API_DEVICE_ID,
  ssoUrl: API_SSO_URL,
  client_id: API_CLIENT_ID,
  client_secret: API_CLIENT_SECRET,
  googleAPiKey: GOOGLE_API_KEY,
  irsUrl: API_IRS_URL,
  enabledComponents: ENABLED_COMPONENTS,
  ssoManagementOnly: SSO_MANAGEMENT_ONLY,
};
export default configs;
